"use strict";
/**
 *
 * FormState/useFormState
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
const react_plumb_1 = require("@domonda/react-plumb");
const FormContext_1 = require("../FormContext");
function useFormState(selector, props) {
    const form = FormContext_1.useFormContext();
    const [state] = react_plumb_1.useMappedPlumbState(Object.assign({ plumb: form.plumb, mapper: selector }, props));
    return [state, form];
}
exports.useFormState = useFormState;
